import store from '@/store'
import i18n from '@/i18n'
import Notify from 'quasar/src/plugins/Notify.js';

import usersService from '@/services/modules/users'
import { slugs } from '@/local-shared/mixins/slugs'

const state = {
    cart: [],

    library: [],
}

const getters = {
    itemCount: (state) => {
        return state.cart.length
    },

    cart: (state) => {
        return state.cart
    },

    library: (state) => {
        return state.library
    },
}

const mutations = {
    addItemToCart(state, newItem) {
        let cartItem = state.cart.find((course) => course.id === newItem.id) // course in already in cart
        // let libraryItem = state.library.find(
        //     (course) => course.course_id === newItem.id
        // ) // course is already in user library
        let user = store.getters['session/user'] // get user data

        // if course is in cart
        if (cartItem) {
            // if user is logged in
            if (user) {
                // check if is a student
                if (user.userRoles.name === slugs.userRoles.student) {
                    // notify that course is already in cart
                    Notify.create({
                        type: 'negative',
                        message: i18n.t('errors.course_already_in_cart'),
                    })
                } else {
                    // add more quantity to course in cart
                    cartItem.quantity++
                    // User cart is stored
                    store.commit('cart/updateUserCart', user)
                    // notify course added to cart
                    Notify.create({
                        type: 'positive',
                        message: i18n.t('success.course_added_to_cart'),
                    })
                }
            } else {
                // user is not logged in
                // notify that course is already in cart
                Notify.create({
                    type: 'negative',
                    message: i18n.t('errors.course_already_in_cart'),
                })
            }
        } else {
            // course is not in cart
            state.cart.push({
                id: newItem.id,
                quantity: 1,
                preferred_class_id: newItem.preferred_class_id,
            })
            Notify.create({
                type: 'positive',
                message: i18n.t('success.course_added_to_cart'),
            })
            // if user is logged in
            if (user) {
                // User cart is stored
                store.commit('cart/updateUserCart', user)
            }
        }
    },

    removeItemFromCart(state, item) {
        let cartItemIndex = state.cart.findIndex(
            (course) => course.id === item.id
        )
        let user = store.getters['session/user'] // get user data

        if (cartItemIndex != -1) {
            state.cart.splice(cartItemIndex, 1)
            // state.total -= state.cartPrices[cartItemIndex].total
            // state.cartPrices.splice(cartItemIndex, 1)

            if (user) {
                // User cart is stored
                store.commit('cart/updateUserCart', user)
            }
        }
    },

    emptyCart(state) {
        let user = store.getters['session/user'] // get user data

        state.cart = []

        if (user) {
            // User cart is stored
            store.commit('cart/updateUserCart', user)
        }
    },

    setQuantity(state, params) {
        let cartItem = state.cart.find(
            (course) => course.id === params.course.id
        )
        let user = store.getters['session/user'] // get user data

        if (cartItem) {
            cartItem.quantity = parseInt(params.quantity, 10)
        }

        if (user) {
            // User cart is stored
            store.commit('cart/updateUserCart', user)
        }
    },

    mergeCart(state, user) {
        let userCart = user.cart !== null ? JSON.parse(user.cart) : []
        let guestCart = state.cart
        let merged = [...userCart, ...guestCart]
        state.cart = []

        merged.forEach((cartItem) => {
            store.commit('cart/addItemToCart', cartItem)
        })
    },

    async updateUserCart(state, user) {
        user.cart = JSON.stringify(state.cart)
        user.currency = JSON.parse(user.userConfiguration.configuration)[
            'currency'
        ]

        let parameters = {
            id: user.id,
            cart: user.cart 
        }

        let response = await usersService.updateCart({ data: [parameters] })

        if (response.status === 200) {
            store.dispatch('session/setUser', { ...user })
        } else {
            Notify.create({
                type: 'negative',
                message: i18n.$t('notify.error_occurred', {
                    message: response.data.message,
                }),
            })
        }
    },

    updateLibary(state, library) {
        state.library = library
    },

    updateCartByLibrary(state, library) {
        state.cart.forEach((course) => {
            let cartItem = library.find((item) => item.id === course.id)

            if (cartItem) {
                store.commit('cart/removeItemFromCart', cartItem)
            }
        })
    },
}

const actions = {
    addItemToCart(context, item) {
        context.commit('addItemToCart', item)
    },

    removeItemFromCart(context, item) {
        context.commit('removeItemFromCart', item)
    },

    emptyCart(context) {
        context.commit('emptyCart')
    },

    setQuantity(context, params) {
        context.commit('setQuantity', params)
    },

    mergeCart(context, user) {
        context.commit('mergeCart', user)
    },

    updateUserCart(context, user) {
        context.commit('updateUserCart', user)
    },

    updateLibary(context, library) {
        context.commit('updateLibary', library)
    },

    updateCartByLibrary(context, library) {
        context.commit('updateCartByLibrary', library)
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
}
